import { ReduxState } from '../../store'

export const getProperties = (state: ReduxState) => state.property.properties

export const getPropertiesLoaded = (state: ReduxState) =>
  state.property.propertiesLoaded

export const currentProperty = (state: ReduxState) =>
  state.property.currentProperty
